<script setup>
import { ref, toRaw, computed } from 'vue';
import { useQuery } from 'villus';
import BlogFeaturedList from '@/components/blog-cta/BlogFeaturedList.vue';
import SentierActualitesLarge from '@/icons/sentier-actualites-large.svg';
import Wave from '@/icons/wave.svg';
import { useStore } from '@/store/Store.js';
import WaveCurve from '@/icons/wave-curve.svg';

const props = defineProps({
    data: {
        type: Object,
        default: () => {},
    },
    color: {
        type: String,
        default: '',
    },
    themeColor: {
        type: String,
        default: '',
    },
});

const store = useStore();
const variables = computed(() => ({ lang: store.lang.value }));

let posts = props.data.data.selectedBlogs;

if (!props.data.data || !props.data.data.selectedBlogs || props.data.data.selectedBlogs.length == 0) {
    const { data: queryData } = await useQuery({
        variables,
        query: `
        query FetchSentier($lang: [String]) {
            selectedBlogs: entries (section: "blog", orderBy: "postDate DESC", limit: 4, site: $lang) {
                uri,
                title,
                day: postDate @formatDateTime (format: "d"),
                month: postDate @formatDateTime (format: "n"),
                year: postDate @formatDateTime (format: "Y"),
                ... on blog_Entry {
                    category: blogCategory { title },
                    cover: blogCover { title, url @transform (format: "webp", quality: 80, width: 800, height: 426, immediately: true) },
                }
            }
        }`,
    });

    posts = queryData.value.selectedBlogs;
}

const attrs = computed(() => ({
    blogs: posts,
    'cta-target': '',
    'title-top': props.data.data.featuredContentTitle,
    'cta-link': props.data.data.link?.[0]?.url ?? null,
    cta: props.data.data.link?.[0]?.text ?? null,
}));
</script>
<template>
    <div
        v-if="data"
        class="relative top-0 bg-light-yellow pb-20 text-dark-yellow md:pb-40 xl:-top-6"
    >
        <div class="absolute w-full -translate-y-[99%] md:-top-10 md:translate-y-[0]">
            <WaveCurve class="block w-full fill-current text-light-yellow md:hidden md:-translate-y-[40%]" />
            <Wave class="hidden fill-current text-light-yellow md:block 3xl:w-full" />
        </div>
        <div class="relative pt-12 text-dark-yellow sm:pt-24 md:pt-18 xl:pt-0">
            <div
                class="absolute -top-9 left-6 h-auto w-42 w-[40%] sm:-top-12 md:-top-10 md:-top-17 md:w-70 md:w-[508px] md:max-w-[30%] md:max-w-[35%] xl:left-20 xl:max-w-[20%]"
            >
                <SentierActualitesLarge />
            </div>

            <BlogFeaturedList
                type="home"
                color="dark-yellow"
                ga-label="voirTousArticles"
                v-bind="attrs"
                list-type="home"
                class="lg:mt-5 xl:mt-0 md:pt-10"
                :wysiwyg-data="data.data.featuredContentText"
            />
        </div>
    </div>
</template>
